// 结算信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'
import {ACCOUNT_CARD_TYPE_LIST} from '@/config-JP/sign/enums'

export default (state) => {
  let contractInfo = get(state, 'currentContractorDetail.contractInfo', {})
  let currentAllConfig = get(state, 'currentAllConfig', {})
  let bankResult = ''
  if (currentAllConfig.bank && currentAllConfig.bank.length > 0) {
    for (let item of currentAllConfig.bank.values()) {
      if (item.key === contractInfo.accountBank) {
        bankResult = item.value
      }
    }
  }
  return {
    title: i18n.gettext('结算信息'),
    content: [
      {
        title: i18n.gettext('银行名称'),
        label: bankResult
      },
      {
        title: i18n.gettext('支行名称'),
        label: contractInfo.accountBankBranch
      },
      {
        title: i18n.gettext('支行号'),
        label: contractInfo.accountBankBranchNo
      },
      {
        title: i18n.gettext('账户类型'),
        // todo这里需要修改银行名称的select的item的值
        label: ACCOUNT_CARD_TYPE_LIST.find(item => item.value === contractInfo.accountCardType) ? ACCOUNT_CARD_TYPE_LIST.find(item => item.value === contractInfo.accountCardType).text : ''
      },
      {
        title: i18n.gettext('账号'),
        label: contractInfo.accountCardno
      },
      {
        title: i18n.gettext('账号名称'),
        label: contractInfo.accountLastName
      }
    ]
  }
}
